module.exports = "<section ng-if=\"$ctrl.data.length\">\r\n<recursoshumanos-pagos-sua-lista-agrupacion\r\n    ng-repeat=\"(indicador, grupos) in $ctrl.data | groupBy: 'indicador' track by indicador\"\r\n    data=\"grupos\"\r\n    indicador=\"indicador\"\r\n    bimestral=\"$ctrl.bimestral\"\r\n    on-select=\"$ctrl.seleccionarMultiple($event.items, $event.seleccionado)\"></recursoshumanos-pagos-sua-lista-agrupacion>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/recursoshumanos/components/pagossua/lista/template.html
// module id = 735
// module chunks = 0